import { AssetImage, EnumOwnerType } from "gql/generated";
import { OperatorDoorstopCard } from "./OperatorDoorstopCard";
import { OrganizationDoorstopCard } from "./OrganizationDoorstopCard";

export type DoorstopItem = {
  _entityId: string;
  path: string;
  name: string;
  image: AssetImage;
  type: EnumOwnerType;
  claimed?: boolean;
  address?: string;
};

export type DoorstopCardProps = {
  doorstopItem: DoorstopItem;
  onItemClick?: (item: DoorstopItem) => void;
};

export const DoorstopCard = ({
  doorstopItem,
  onItemClick,
}: DoorstopCardProps) => {
  if (doorstopItem.type === EnumOwnerType.Operator) {
    return (
      <OperatorDoorstopCard
        doorstopItem={doorstopItem}
        onItemClick={onItemClick}
      />
    );
  }

  return (
    <OrganizationDoorstopCard
      doorstopItem={doorstopItem}
      onItemClick={onItemClick}
    />
  );
};
